/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PastMedicalHistoryDto } from './PastMedicalHistoryDto';
import {
    PastMedicalHistoryDtoFromJSON,
    PastMedicalHistoryDtoFromJSONTyped,
    PastMedicalHistoryDtoToJSON,
    PastMedicalHistoryDtoToJSONTyped,
} from './PastMedicalHistoryDto';

/**
 * 
 * @export
 * @interface MedicalHistoryRequestDto
 */
export interface MedicalHistoryRequestDto {
    /**
     * Past medical history
     * @type {PastMedicalHistoryDto}
     * @memberof MedicalHistoryRequestDto
     */
    pastMedicalHistory?: PastMedicalHistoryDto;
    /**
     * Surgeries/hospitalizations
     * @type {string}
     * @memberof MedicalHistoryRequestDto
     */
    surgeriesHospitalizations?: string;
    /**
     * Significant injuries
     * @type {string}
     * @memberof MedicalHistoryRequestDto
     */
    significantInjuries?: string;
    /**
     * Allergies
     * @type {string}
     * @memberof MedicalHistoryRequestDto
     */
    allergies?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof MedicalHistoryRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the MedicalHistoryRequestDto interface.
 */
export function instanceOfMedicalHistoryRequestDto(value: object): value is MedicalHistoryRequestDto {
    return true;
}

export function MedicalHistoryRequestDtoFromJSON(json: any): MedicalHistoryRequestDto {
    return MedicalHistoryRequestDtoFromJSONTyped(json, false);
}

export function MedicalHistoryRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalHistoryRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pastMedicalHistory': json['pastMedicalHistory'] == null ? undefined : PastMedicalHistoryDtoFromJSON(json['pastMedicalHistory']),
        'surgeriesHospitalizations': json['surgeriesHospitalizations'] == null ? undefined : json['surgeriesHospitalizations'],
        'significantInjuries': json['significantInjuries'] == null ? undefined : json['significantInjuries'],
        'allergies': json['allergies'] == null ? undefined : json['allergies'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function MedicalHistoryRequestDtoToJSON(json: any): MedicalHistoryRequestDto {
    return MedicalHistoryRequestDtoToJSONTyped(json, false);
}

export function MedicalHistoryRequestDtoToJSONTyped(value?: MedicalHistoryRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pastMedicalHistory': PastMedicalHistoryDtoToJSON(value['pastMedicalHistory']),
        'surgeriesHospitalizations': value['surgeriesHospitalizations'],
        'significantInjuries': value['significantInjuries'],
        'allergies': value['allergies'],
        'isOnboarding': value['isOnboarding'],
    };
}

